module.exports = __webpack_public_path__ + "img/24hoursfill.c6f69ae2.svg";